import { Box, Fab, Tooltip } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { GOLD, GOLDF } from '../theme/theme';

export default function WhatsAppFAB({ onEnquire }) {
  return (
    <Tooltip title="Chat with us" placement="left">
      <Fab onClick={onEnquire} sx={{
        position: 'fixed', bottom: 24, right: 24, zIndex: 1000,
        bgcolor: '#25d366', '&:hover': { bgcolor: '#1ebe57', transform: 'scale(1.1)' },
        width: 56, height: 56,
        boxShadow: `0 4px 20px rgba(37,211,102,0.40), 0 0 0 2px rgba(201,150,12,0.25)`,
        border: `1.5px solid rgba(201,150,12,0.30)`,
        transition: 'transform 0.2s, box-shadow 0.2s',
      }}>
        <WhatsAppIcon sx={{ fontSize: 28, color: '#fff' }} />
      </Fab>
    </Tooltip>
  );
}
